// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__1RgSg","SpinnerContainer":"Spinner_SpinnerContainer__rG5hH","Icon":"Spinner_Icon__-Is0Z","spin":"Spinner_spin__Q9zsz"};